import React, { useEffect } from "react";
import { useLocation, useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setEmailAction } from "../store/actions/emailTemplatesActions/emailTempActions";
import { handleEmailAction } from "src/Utils/emailActions";

const EmailActionHandler = () => {
  const location = useLocation();
  const history = useHistory(); // v5
  const dispatch = useDispatch();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const result = handleEmailAction(searchParams);

    if (result) {
      dispatch(setEmailAction(result));
      console.log("Stored Email Action:", result);

      // Clean URL to prevent re-triggering
      // history.replace(location.pathname);
    }
  }, [location.search, dispatch, history, location.pathname]);

  return null; // no UI, logic only
};

export default EmailActionHandler;
